import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  /*  en: {
     welcome: 'Welcome',
     // tus traducciones aquí
   }, */
  es: {
    "Experience": "Experiencia",
    "Address": "Dirección",
    "Phone Number": "Número de Teléfono",
    "Email Address": "Correo Electrónico",
    "Short Bio": "Breve Biografía",
    "Request Appointment": "Solicitar Cita",
    "Your Information": "Su Información",
    "First Name": "Nombre",
    "Last Name": "Apellido",
    "Date of Birth": "Fecha de Nacimiento",
    "Month": "Mes",
    "Day": "Día",
    "Year": "Año",
    "Insurer": "Aseguradora",
    "Contract Number": "Número de Contrato",
    "Policy Number":"Número de Póliza",
    "Appointment Preferences": "Preferencias de Cita",
    "Request Type": "Tipo de Solicitud",
    "Appointment Type": "Tipo de Cita",
    "Select Appointment type": "Seleccione el tipo de cita",
    "Select request type": "Seleccione el tipo de solicitud",
    "Preferred Date": "Fecha Preferida",
    "Select a date": "Seleccione una fecha",
    "Important Information": "Información Importante",
    "Required Documents & Info": "Documentos e Información Requeridos",
    "Click to upload": "Haga clic para subir",
    "completed": "completado",
    "Available Time Slots": "Horarios Disponibles",
    "Show More Slots": "Mostrar más horarios",
    "No availability for the selected date.": "No hay disponibilidad para la fecha seleccionada.",
    "Please try selecting another day.": "Por favor, intente seleccionando otro día.",
    "Additional Notes": "Notas Adicionales",
    "Optional": "Opcional",
    "Briefly describe your symptoms or reason for visit...": "Describa brevemente sus síntomas o el motivo de la visita...",
    "Processing...": "Procesando...",
    "Request Sent!": "¡Solicitud Enviada!",
    "Your Appointment has been received.!": "¡Su cita ha sido recibida!",
    "Our team will contact you soon.": "Nuestro equipo se pondrá en contacto con usted pronto.",
    "This is not an Appointment!": "¡Esto no es una cita médica confirmada!",
    "New Request": "Nueva Solicitud",
    "Terms and Conditions": "Términos y Condiciones",
    "Agreement & Terms": "Acuerdo y Términos",
    "Decline": "Rechazar",
    "Accept & Request Appointment": "Aceptar y Solicitar Cita",
    "Accept & Confirm": "Aceptar y Confirmar",
    "+ Years": "años o más",
    "Select": "Seleccione",
    "Care Center": "Centro Médico",
    "AFTERNOON": "TARDE",
    "MORNING": "MAÑANA",
    "NOON": "MEDIODIA",
    "NIGHT": "NOCHE",
    "ANY TIME": "CUALQUIER HORA",
    "General Information":"Información General",
    "Appointment Request":"Solicitud de cita",
    "Available Sessions":"Tandas Disponibles",
    "Duration":"Duración",
    "Sorry, the selected appointment time is no longer available. Please select a different time slot or session.":"Lo sentimos, el horario de la cita seleccionada ya no está disponible. Por favor, elija otro horario o sesión disponible.",
    "Time Slot Unavailable":"Horario no disponible",
    "We’re sorry, an unexpected error occurred while submitting the request. Please try again.":"Lo sentimos, ocurrió un error inesperado al enviar la solicitud. Por favor, inténtelo de nuevo."
  }
};

const i18n = new VueI18n({
  locale: 'en', // idioma por defecto
  fallbackLocale: 'en',
  messages,
});

export default i18n;